import script from "./AuthorizePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthorizePage.vue?vue&type=script&lang=ts&setup=true"

import "./AuthorizePage.vue?vue&type=style&index=0&id=4e90b60c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e90b60c"]])

export default __exports__